// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"130":"6c750eda","620":"6c750eda"}[chunkId] + ".chunk.css";
};